export const LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_3483d31b-a42f-4b2b-92f7-e812e0a16520/artifacts/iwwa1twv_splendi_senza_sfondo.png";
